/* tf.js — Truffio v2. This block IS the future assets/tf.js. Vanilla only. */
(function () {
  var doc = document.documentElement;
  doc.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveals: plain descendant query, IO + top<0 + rAF-throttled sweep, once */
  var items = Array.prototype.slice.call(document.querySelectorAll('.tf-r, .tf-hero, .tf-banner'));
  function show(el) { el.classList.add('is-in'); }
  if (reduce || !('IntersectionObserver' in window)) { items.forEach(show); }
  else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting || e.boundingClientRect.top < 0) { show(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
    var ticking = false;
    function sweep() {
      ticking = false;
      var h = window.innerHeight;
      items.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < h * 0.92 || r.top < 0) { show(el); io.unobserve(el); }
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }, { passive: true });
    setTimeout(sweep, 60);
  }

  /* shop tabs: one grid per set, toggled with data-off; the panel link follows the set */
  Array.prototype.forEach.call(document.querySelectorAll('[data-tabs]'), function (root) {
    var tabs = root.querySelectorAll('.tf-tab'), grids = root.querySelectorAll('[data-set]'), head = root.querySelector('[data-set-title]'), link = root.querySelector('[data-set-link]');
    Array.prototype.forEach.call(tabs, function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-tab');
        Array.prototype.forEach.call(tabs, function (x) { x.classList.toggle('is-on', x === t); });
        Array.prototype.forEach.call(grids, function (g) { if (g.getAttribute('data-set') === key) g.removeAttribute('data-off'); else g.setAttribute('data-off', ''); });
        if (head) head.textContent = t.getAttribute('data-title');
        if (link) { link.setAttribute('href', t.getAttribute('data-href')); link.firstChild.textContent = t.getAttribute('data-link'); }
      });
    });
  });

  /* review slides: prev / next over the slides in the card */
  Array.prototype.forEach.call(document.querySelectorAll('[data-slides]'), function (root) {
    var slides = root.querySelectorAll('.tf-slide'), i = 0;
    function go(n) { i = (n + slides.length) % slides.length; Array.prototype.forEach.call(slides, function (s, k) { if (k === i) s.removeAttribute('data-off'); else s.setAttribute('data-off', ''); }); }
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
  });
})();

/* ---- theme-only additions (not in the mock): header "Shop now" pill + working card quick-add ---- */
(function () {
  /* the skin section renders <template id="tf-header-cta">; append its content into the native header's right group (desktop only via CSS) */
  var tpl = document.getElementById('tf-header-cta');
  var right = document.querySelector('.m-header__right');
  if (tpl && right && !right.querySelector('.tf-header__cta')) right.appendChild(tpl.content.cloneNode(true));

  /* card "+" = add the first available variant, then open Minimog's cart drawer (cart.js listens for cart:refresh {open:true}) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-add'), 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } })); })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { btn.classList.remove('is-busy'); });
  });
})();
